import { CmsSellerFilters } from '../../../../domain/seller'
import { HTMLInputMapId, RADIUS_TYPE_KM } from '../constants'
import { convertMilesToKm } from '../helper'

import { BaiduHTMLSellersMapId } from './constants'
import { BaiduFormData, BaiduInitAutoCompleteOptions, BaiduPlace } from './types'

export const baiduInitAutoComplete = ({
  onChangePlace,
}: BaiduInitAutoCompleteOptions): BMap.Autocomplete | null => {
  try {
    const mapInputCitiesEl = document.querySelector(`#${HTMLInputMapId}`)
    if (!mapInputCitiesEl) {
      return null
    }

    const autoComplete = new BMap.Autocomplete({
      input: mapInputCitiesEl,
    })

    autoComplete.addEventListener('onconfirm', (e) => {
      const geocoder = new BMap.Geocoder()
      geocoder.getPoint(e.item.value.city, (resultGeo) => {
        onChangePlace({
          address: { city: e.item.value.city },
          latitude: resultGeo.lat,
          longitude: resultGeo.lng,
        })
      })
    })

    return autoComplete
  } catch (e) {
    console.warn(e) // eslint-disable-line
    return null
  }
}

export const baiduTransformFormDataToCmsSellerFilter = (
  formData: BaiduFormData,
): CmsSellerFilters => {
  const filters: CmsSellerFilters = {}

  if (formData.place) {
    if (formData.place.latitude && formData.place.longitude) {
      const valueRadius = formData.radius || 20

      filters.radius = {
        lat: formData.place.latitude,
        lng: formData.place.longitude,
        value: formData.typeRadius === RADIUS_TYPE_KM ? convertMilesToKm(valueRadius) : valueRadius,
      }
    }
  }

  if (formData.type && formData.type !== 'all') {
    filters.type = formData.type
  }

  if (formData.categories?.length) {
    filters.categories = [...formData.categories]
  }

  return filters
}

export const baiduFetchCityFromGeolocationPosition = async (): Promise<BaiduPlace | void> => {
  const geolocation = new BMap.Geolocation()
  return new Promise((resolve, reject) => {
    geolocation.getCurrentPosition((r) => {
      if (geolocation.getStatus() === 0) {
        return resolve({
          address: { city: r.address.city },
          latitude: r.point.lat,
          longitude: r.point.lng,
        })
      }
      reject('error')
    })
  })
}

export const baiduGetMapEl = () => document.querySelector(`#${BaiduHTMLSellersMapId}`)
